import { Modal } from 'antd';
import { FC } from 'react';
import { ControlType, formDataComsToTiled } from '../../DynamicComponent/config';
import { addressIdentification, networkPlanningIdentification } from '../../DynamicComponent/customize';

/**
 * @Description 按照表单数据判断是否机会点是否在所属商圈中的提示弹窗
 */
const ClusterHintModal:FC<{
  clusterHintModalOpen,
  setClusterHintModalOpen,
  confirmClose,
  // form,
  tiledFormDataRef,
  formData
}> = ({
  clusterHintModalOpen,
  setClusterHintModalOpen,
  confirmClose,
  // form,
  tiledFormDataRef,
  formData
}) => {
  // 退出
  const handleExit = () => {
    setClusterHintModalOpen(false);
    confirmClose();
  };
  // 重新录入
  const handleReEntry = () => {
    setClusterHintModalOpen(false);
    let arr = tiledFormDataRef.current;
    if (!arr.length) {
      formDataComsToTiled(formData.propertyGroupVOList, tiledFormDataRef.current);
      arr = tiledFormDataRef.current;
    }
    const addressTargetCom = arr.find((item: any) => item.identification === addressIdentification);
    if (!addressTargetCom) return;
    // 修改地址组件值
    addressTargetCom.textValue = null;

    // 清空网规信息
    const businessTargetCom = arr.find((item: any) => +item.controlType === ControlType.BUSINESS_PLANNING.value && item.identification === networkPlanningIdentification);
    if (!businessTargetCom) return;
    businessTargetCom.textValue = null;
  };


  return <Modal
    title='系统提示'
    cancelText='重新录入'
    zIndex={3000}
    okText='退出'
    okButtonProps={{
      danger: true,
    }}
    open={clusterHintModalOpen}
    onOk={handleExit}
    onCancel={handleReEntry}>
    <div>当前录入的机会点未在规划商圈内，不符合公司选址要求，请重新录入其他机会点！</div>
  </Modal>
  ;
};
export default ClusterHintModal;
